import noRelativeImports from "./no-relative-imports";
import noAbsoluteImports from "./no-absolute-imports";
import onlyAbsoluteImports from "./only-absolute-imports";

export const rules = {
  noRelativeImports,
  noAbsoluteImports,
  onlyAbsoluteImports,
};
